// components/CustomDataTable.js
import React, { useState, useMemo } from "react";
import DataTable from "react-data-table-component";

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#0d6efd",
      color: "white",
      fontWeight: "bold",
      fontSize: "10px",
      border: "1px solid #dee2e6",
    },
  },
  rows: {
    style: {
      border: "1px solid #dee2e6",
      fontSize: "10px",
    },
  },
  cells: {
    style: {
      border: "1px solid #dee2e6",
    },
  },
  table: {
    style: {
      border: "1px solid #dee2e6",
    },
  },
};

// 🔹 Utility: convert camelCase / snake_case → UPPERCASE WITH SPACES
const formatHeader = (key) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase → camel Case
    .replace(/_/g, " ")                  // snake_case → snake case
    .toUpperCase();                      // → UPPERCASE
};

const CustomDataTable = ({ data, title, autoColumns = true }) => {
  const [search, setSearch] = useState("");

  // 🔹 Build columns automatically from first row of data
  const columns = useMemo(() => {
    if (!autoColumns || data.length === 0) return [];

    return Object.keys(data[0]).map((key) => ({
      name: formatHeader(key), // ✅ Heading in UPPERCASE
      selector: (row) => row[key],
      sortable: true,
      wrap: true,
    }));
  }, [data, autoColumns]);

  // 🔹 Apply search filter
  const filteredData = data.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <DataTable
      // title={title}
      columns={columns}
      data={filteredData}
      pagination
      highlightOnHover
      striped
      dense
      fixedHeader
      fixedHeaderScrollHeight="400px"
      customStyles={customStyles}
      subHeader
      subHeaderComponent={
        <input
          type="text"
          placeholder="Search..."
          className="form-control w-25"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      }
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 50]}
    />
  );
};

export default CustomDataTable;
